/* eslint-disable no-param-reassign */
/*
 * @Author: luting
 * @Date: 2022-04-19 18:54:08
 * @lastEditors: luting
 * @LastEditTime: 2023-08-29 18:00:24
 */
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import * as zip from '@zip.js/zip.js';
import { parse } from 'js-ini';
import * as packManage from '../store/actions';
import md5 from 'js-md5';

import { Button, message, Spin, Modal } from 'sup-ui';
import messages from '../messages';
import InitPage from './InitPage';
import PackDetail from './PackDetail';
import CommonModal from 'root/components/CommonModal';

import {
  getPacklistApi,
  deletePackApi,
  unzipPackApi,
  getPackApi,
  // deleteCheckApi,
  bigfileCheckApi,
  bigfileUpload,
  bigfileMerge,
  bigfileCancel,
} from 'root/services/packageManage';
// import { uploadModule } from 'root/services/manager';

import { UpdateQueueType } from '../store/types';

import styles from '../index.less';

const { confirm } = CommonModal;
const SIZE = 1024 * 1024 * 1;

let timer: any = null;

let uploadTasks: any = [];

const List = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const inputUploadRef = useRef<HTMLInputElement>(null);
  const { queueState } = useSelector((state: any) => state.packManage);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState<any>({});

  useEffect(() => {
    getCompleteData();
  }, []);

  useEffect(() => {
    if (!queueState.length) return;
    if (_.some(queueState, (item: any) => [2, 4].includes(item?.uploadStatus))) {
      window.isBeforeunloadTip = true;
    }
    return () => {
      window.isBeforeunloadTip = false;
    };
  }, [queueState]);

  // 轮询查状态
  const loopStatus = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      getCompleteData();
    }, 20 * 1000);
  };

  // 获取已经上传完成的数据, 将数据拉平
  const getCompleteData = () => {
    getPacklistApi().then((res) => {
      const { data = [] } = res;
      // 备份数据传递给组件用于判断是否重复
      const catelogList: any = [];
      // 循环每个分类，将的detail数据拉平并将外层数据添加给单条数据
      data.forEach((item: any) => {
        const { specifics, description, name } = item;
        specifics.forEach((ele: any) => {
          // 解压中轮询查状态
          if (ele.uploadStatus === 4) {
            loopStatus();
          }
          catelogList.push({
            ...ele,
            description,
            name,
            uploadStatus: ele.uploadStatus,
          });
        });
      });
      // 更新队列
      dispatch(packManage.addQueue({ queue: catelogList }));
      dispatch(packManage.diffQueue(catelogList));
    });
  };

  // 点击按钮触发文件选择
  const toggleUpload = () => {
    inputUploadRef.current?.click();
  };

  const tipErrorModal = (content: string) => {
    // 清空input
    if (inputUploadRef.current) {
      inputUploadRef.current.value = '';
    }
    confirm({
      title: content,
      okText: intl.formatMessage(messages.sure),
    });
  };

  // 上传前解压获取组件类型
  const beforeUpload = async (e: any) => {
    const { files = [] } = e.target;
    let i = 0;
    const len = files.length;
    const updateContent = [];

    while (i < len) {
      const file = files[i];
      const fileName = file.name;
      const isZip = fileName.endsWith('.zip') || fileName.endsWith('.rar');
      // 读取包内数据
      const entries = await new zip.ZipReader(new zip.BlobReader(files[i])).getEntries();
      const versionFile = entries.filter((item) => item.filename === 'version')?.[0];

      // 排除不符合要求的压缩包
      if (!isZip || !versionFile || !versionFile.getData) {
        tipErrorModal(intl.formatMessage(messages.fileCheckTip));
        return;
      }

      // 提取包内数据
      const content = await versionFile.getData(new zip.TextWriter());
      const { ModuleName, MajorVersion, Render, Catalog, DiffFrom } = parse(content);

      // if (!Catalog) {
      //   tipErrorModal(intl.formatMessage(messages.renderLost));
      //   return;
      // }
      // 不校验catalog缺少情况

      try {
        JSON.parse(Render as string);
      } catch (error) {
        tipErrorModal(intl.formatMessage(messages.renderLost));
        return;
      }
      const { title, subTitle } = JSON.parse(Render as string);

      i++;

      const params = {
        catalog: Catalog || 'extension', // 没有拿到catalog 则默认为扩展包
        title,
        subTitle,
        name: ModuleName,
        file,
        version: MajorVersion,
        type: !DiffFrom ? 1 : 2, // 整包是1  补丁包是2
        fileName,
        viewId: `${Catalog || 'extension'}-${ModuleName}-${MajorVersion}`,
        hash: '',
      };

      updateContent.push(params);
    }

    // 清空input
    if (inputUploadRef.current) {
      inputUploadRef.current.value = '';
    }

    // 更新队列
    updateUploadQueue(updateContent);
  };

  // 更新上传队列
  const updateUploadQueue = async (params: any[]) => {
    const newUploadQueue: UpdateQueueType[] = [];
    let repeat = false; // 是否在外部列表已经存在

    params.forEach((data: any) => {
      try {
        const { viewId } = data;
        // 与上传完成的列表中的数据是否重复
        if (
          queueState
            // .filter((item: any) => item.uploadStatus !== 1)
            .map((item: any) => item.viewId)
            .includes(viewId)
        ) {
          repeat = true;
          return;
        }

        newUploadQueue.push({
          ...data,
          uploadPrecent: 0,
          uploadStatus: 2,
          viewId,
          errorNum: 0,
        });
      } catch (err) {
        console.log(err);
      }
    });

    // 安装包列表中已存在,报提示信息
    if (repeat) {
      confirm({
        title: intl.formatMessage(messages.packRepeat),
        okText: intl.formatMessage(messages.sure),
      });
      return;
    }

    // 不存在符合条件的上传项
    if (newUploadQueue.length === 0) {
      confirm({
        title: intl.formatMessage(messages.uploadRequiredModuleTitleTip),
        content: intl.formatMessage(messages.existContentTip),
        okText: intl.formatMessage(messages.sure),
      });
      return;
    }
    dispatch(packManage.addPack({ queue: newUploadQueue }));
    startUpload(newUploadQueue, false);
  };

  // 上传失败
  const uploadError = (detail: string, task: any) => {
    // 上传失败 取消事件取消，进度为0,保存失败原因，状态为失败。
    dispatch(
      packManage.updateQueue({
        uploadPrecent: 0,
        cancel: null,
        uploadDetail: detail,
        uploadStatus: 1,
        hash: '',
        viewId: task.viewId,
        catalog: task.catalog,
        errorNum: 0,
        uploadTask: task,
      }),
    );
  };

  // 对文件进行分片上传
  const startUpload = async (newUploadQueue: any, isRemoveOldTASK: boolean) => {
    newUploadQueue.forEach((item: any) => {
      const { file, viewId, catalog } = item;

      item.hash = md5(item.fileName); // 获取文件hash值，用于判断文件是否唯一
      dispatch(packManage.updateQueue({ uploadPrecent: 0, uploadStatus: 2, hash: item.hash, viewId, catalog }));
      // 获取是否已经上传过分片，从而判断当前文件应该从第几个分片开始上传
      bigfileCheckApi({
        fileMD5: item.hash,
      })
        .then(async (res: any) => {
          const { process } = res.data;
          item.countChunk = Math.ceil(file.size / SIZE);
          // 如果所有分片全部上传完成直接调用合并接口
          if (process >= item.countChunk - 1) {
            uploadComplete(item);
          } else {
            // 分片上传了一定数量但是没有上传完成
            item.currentUploadIndex = process;
            // 如果是重试需要删除队列中老的任务
            if (isRemoveOldTASK) {
              removeUploadTaskByViewId(viewId);
            }
            // 开始上传的时候添加到上传队列中
            uploadTasks.push(item);
            // 判断当前上传的分片索引是否小于总分片数量，如果小于进入循环开始上传分片
            while (item.currentUploadIndex < item.countChunk && item.errorNum < 5) {
              const currentUploadSize = item.currentUploadIndex * SIZE;
              const uploadFile = file.slice(currentUploadSize, currentUploadSize + SIZE);
              const formData = new FormData();
              formData.append('file', uploadFile);
              formData.append('chunks', item.countChunk);
              formData.append('chunk', item.currentUploadIndex);
              formData.append('name', item.fileName);
              formData.append('md5', item.hash);
              // 上传分片
              await wait(item.errorNum); // wait for errorNum * 1000 seconds
              await startMultipartUpload(formData, item);
            }
            // 判断如果当前上传的索引大于等于总数
            if (item.currentUploadIndex >= item.countChunk) {
              uploadComplete(item);
              return;
            }
          }
        })
        .catch(() => {
          uploadError('上传文件失败，请检查网络配置，重试上传文件！', item);
        });
    });
  };

  // 等待几秒
  const wait = (seconds: number) => {
    if (seconds === 0) return;
    return new Promise((resolve) => {
      console.log(`wait for ${seconds} seconds`);
      setTimeout(resolve, seconds * 1000);
    });
  };

  // 分片上传
  const startMultipartUpload = async (formData: FormData, item: any) => {
    await bigfileUpload(formData)
      .then(() => {
        dispatch(
          packManage.updateQueue({
            uploadPrecent: Math.min(Math.floor(((item.currentUploadIndex * 100) / item.countChunk) * 100) / 100, 99.99),
            hash: item.hash,
            viewId: item.viewId,
            catalog: item.catalog,
            errorNum: item.errorNum,
          }),
        );
        item.currentUploadIndex = item.currentUploadIndex + 1;
        item.errorNum = 0;
      })
      .catch(() => {
        item.errorNum += 1;
        // 上传失败 取消事件取消，进度为0,保存失败原因，状态为失败。
        if (item.errorNum > 4) {
          uploadError('上传文件失败，请检查网络配置，重试上传文件！', item);
        }
      });
  };

  // 分片上传完成进行合并
  const uploadComplete = async (task: any) => {
    const { viewId, catalog } = task;
    bigfileMerge({ fileName: task.fileName, md5: task.hash })
      .then((res: any) => {
        const archiveId = res.data;
        if (archiveId) {
          getSingleData(archiveId);
          dispatch(packManage.setOperationPackage(archiveId + 'upload'));
        } else {
          // 上传失败 取消事件取消，进度为0,保存失败原因，状态为失败。
          dispatch(
            packManage.updateQueue({
              uploadPrecent: 0,
              cancel: null,
              uploadDetail: '',
              uploadStatus: 1,
              hash: task.hash,
              viewId,
              catalog,
            }),
          );
        }
      })
      .catch(() => {
        // 上传失败 取消事件取消，进度为0,保存失败原因，状态为失败。
        dispatch(
          packManage.updateQueue({
            uploadPrecent: 0,
            cancel: null,
            uploadDetail: '请求超时',
            uploadStatus: 1,
            hash: task.hash,
            viewId,
            catalog,
          }),
        );
      });
  };

  // 获取单条数据
  const getSingleData = (archiveId: string) => {
    getPackApi(archiveId).then((res) => {
      console.log('getPackApi------', res);
      const {
        data: { specifics = [] },
      } = res;
      const { img = '', uploadTime = '', uploadDetail = '', uploadStatus, viewId, catalog } = specifics[0];
      const obj = {
        img,
        uploadTime,
        uploadDetail,
        uploadPrecent: 100,
        cancel: null,
        archiveId,
        uploadStatus,
        viewId,
        catalog,
        hash: '',
      };
      dispatch(packManage.updateQueue({ ...obj }));
      // 如果是组合包发起解压
      if (catalog === 'bucket') {
        handleUnzip(archiveId, viewId, catalog);
      }
    });
  };

  // 删除
  const deleteTask = (archiveId: string, viewId: string) => {
    if (!archiveId) {
      CommonModal.confirm({
        onOk: () => {
          dispatch(packManage.deleteQueue({ viewId }));
          dispatch(packManage.setOperationPackage(archiveId + 'delelte'));
          uploadTasks = queueState.filter((m: any) => m.viewId !== viewId);
          message.success(intl.formatMessage(messages.deleteTip));
        },
        title: intl.formatMessage(messages.deleteConfirm),
      });
    } else {
      // 4.2.2.0 不做安装包删除前检测
      setDeleteInfo({ archiveId });
      setDeleteVisible(true);

      // deleteCheckApi(archiveId).then((res) => {
      //   setDeleteInfo({ ...res.data, archiveId: archiveId });
      //   setDeleteVisible(true);
      // });
    }
  };

  // 删除指定viewId的数据
  const removeUploadTaskByViewId = (viewId: string) => {
    for (let i = 0; i < uploadTasks.length; i++) {
      if (uploadTasks[i].viewId === viewId) {
        uploadTasks.splice(i, 1);
      }
    }
  };

  // 重试上传
  const resetTask = (viewId: string) => {
    const resetUploadQueue: UpdateQueueType[] = [];
    const uploadTask = uploadTasks.find((item: any) => {
      return viewId === item.viewId;
    });
    uploadTask.errorNum = 0;
    resetUploadQueue.push(uploadTask);
    startUpload(resetUploadQueue, true);
  };

  // 取消上传
  const cancelTask = (viewId: string) => {
    const task = uploadTasks.find((item: any) => {
      return viewId === item.viewId;
    });
    CommonModal.confirm({
      onOk: () => {
        if (task) {
          bigfileCancel({ fileName: task.fileName, md5: task.hash }).then(() => {
            message.success(intl.formatMessage(messages.cancelSuccess));
            dispatch(packManage.deleteQueue({ viewId }));
            uploadTasks = queueState.filter((m: any) => m.viewId !== viewId);
          });
        } else {
          message.success(intl.formatMessage(messages.cancelSuccess));
          dispatch(packManage.deleteQueue({ viewId }));
          uploadTasks = queueState.filter((m: any) => m.viewId !== viewId);
        }
      },
      title: intl.formatMessage(messages.cancelUploadingConfirm),
    });
  };

  // 解压组合包
  const handleUnzip = (id: string, viewId: string, catalog: string) => {
    dispatch(packManage.updateQueue({ viewId, uploadPrecent: 100, uploadStatus: 4, catalog }));
    unzipPackApi(id)
      .then((res) => {
        const { data } = res;
        // 解压成功
        if (data.uploadStatus === 5) {
          getCompleteData();
          message.success(intl.formatMessage(messages.decompressionSuccess));
          dispatch(packManage.setOperationPackage(id + 'unzip'));

          return;
        }
        // 解压失败
        if (data.uploadStatus === 6) {
          message.error(data.uploadMessage);
          dispatch(packManage.updateQueue({ viewId, uploadPrecent: 100, uploadStatus: 0, catalog }));
        }
      })
      .catch(() => {
        dispatch(packManage.updateQueue({ viewId, uploadPrecent: 100, uploadStatus: 0, catalog }));
      });
  };

  // 刷新列表
  const handleRefersh = async () => {
    try {
      getCompleteData();
      message.success(intl.formatMessage(messages.refershSuccess));
    } catch (error) {
      message.error(intl.formatMessage(messages.refershFail));
    }
  };

  return (
    <div className={styles.package_manage_list}>
      <div className={styles.title}>{intl.formatMessage(messages.packageList)}</div>
      <div className={styles.list}>
        <div className={styles.operate}>
          <div>
            <Button type="primary" onClick={toggleUpload}>
              {intl.formatMessage(messages.uploadApp)}
            </Button>
            <input
              style={{ display: 'none' }}
              ref={inputUploadRef}
              type="file"
              multiple
              accept=".zip,.rar,application/x-rar-compressed,application/zip,application/x-zip-compressed,application/octet-stream"
              onChange={beforeUpload}
            />
          </div>

          <Button type="primary" disabled className={styles.from_database}>
            {intl.formatMessage(messages.fromDatabase)}
          </Button>
          <div className={styles.refersh}>
            <Button
              style={{ width: 80 }}
              disabled={_.some(queueState, (item: any) => [2, 4].includes(item.uploadStatus))}
              onClick={handleRefersh}
            >
              {intl.formatMessage(messages.refersh)}
            </Button>
          </div>
        </div>
        <div className={styles.content}>
          {queueState.length ? (
            <PackDetail
              handleDelete={deleteTask}
              handleReset={resetTask}
              handleCancel={cancelTask}
              handleUnzip={handleUnzip}
            />
          ) : (
            <InitPage />
          )}
        </div>
      </div>
      <Modal
        visible={deleteVisible}
        title={intl.formatMessage(messages.deletePackage)}
        onOk={() => {
          setDeleteLoading(true);
          deletePackApi({ archiveId: deleteInfo.archiveId, tasks: deleteInfo.tasks })
            .then(() => {
              message.success(intl.formatMessage(messages.deleteTip));
              dispatch(packManage.deleteQueue({ viewId: deleteInfo.viewId }));
              dispatch(packManage.setOperationPackage(deleteInfo.archiveId + 'delelte'));
              uploadTasks = queueState.filter((m: any) => m.viewId !== deleteInfo.viewId);
              getCompleteData();
              setDeleteVisible(false);
            })
            .finally(() => {
              setDeleteLoading(false);
            });
        }}
        onCancel={() => {
          setDeleteVisible(false);
        }}
        okButtonProps={{ disabled: deleteLoading, style: { width: 88, height: 32 } }}
        cancelButtonProps={{ disabled: deleteLoading, style: { width: 88, height: 32 } }}
      >
        <Spin spinning={deleteLoading} style={{ marginLeft: -30 }}>
          {intl.formatMessage(deleteInfo.showNotice ? messages.deleteRollBackConfirm : messages.deleteConfirm, {
            version: deleteInfo.versions?.join(','),
          })}
        </Spin>
      </Modal>
    </div>
  );
};

export default List;
